@if (isLoading) {
  <app-content-loader></app-content-loader>
}
<div class="step-container columns is-desktop" [class.d-none]="isLoading">
  <app-aside-bar [statement]="statement"></app-aside-bar>
  <div class="thank-you">
    <h1 class="title_42">{{ "THANK_YOU.TITLE" | translate }}</h1>
    @if (statement?.serviceType !== packageOption.tax_adviser) {
      @if (!isVeryfying) {
        <p class="subdesc">{{ "THANK_YOU.DESCRIPTION" | translate }}</p>
      } @else {
        <p class="subdesc">{{ "THANK_YOU.VERIFICATION_PROCESS" | translate }}</p>
      }
    } @else {
      @if (!isVeryfying) {
        <p class="subdesc">{{
          "THANK_YOU.TAX_ADVISER_DESCRIPTION" | translate
        }}</p>
      } @else {
        <p class="subdesc">{{ "THANK_YOU.VERIFICATION_PROCESS" | translate }}</p>
      }
    }

    @if (isIdentityVarificationActive) {
      <div class="thank-you__onfido">
        @if (isVeryfying) {
          @if (!cantGetOnfidoStatusCheck) {
            <div class="thank-you__onfido-verify-info alert-box alert-box--info">
              {{ "ONFIDO.PLACEHOLDER" | translate }}
            </div>
          } @else {
            <div class="thank-you__onfido-verify-info alert-box alert-box--error">
              {{ "ONFIDO.WARNING_MESSAGE.PLEASE_WAIT" | translate }}
            </div>
          }
        }
        <div id="sumsub-websdk-container"></div>
      </div>
    }
  </div>
</div>
